import * as path from 'path';
import {parse, render} from 'mustache';
import {cloneDeep} from 'lodash';
import {TemplateEngineContract} from 'common/templating/TemplateEngineContract';
import {FileSystem} from 'common/tool/FileSystem';
import {asyncForEach} from 'common/util/PromiseUtil';
import {MinifierEngineContract} from 'common/templating/MinifierEngineContract';
import {MinifierEngine} from 'common/templating/MinifierEngine';
import {ConflictException} from 'common/exception/ConflictException';

export class TemplateEngine implements TemplateEngineContract {
    private minifier: MinifierEngineContract;

    public constructor() {
        this.minifier = new MinifierEngine();
    }

    public async render(templatePath: string, data: {[key: string]: any}, baseIncludePath?: string): Promise<string> {
        if (!templatePath.endsWith('.template')) {
            templatePath += '.template';
        }
        const view: {[key: string]: any} = cloneDeep(data);
        const basePath: string = path.isAbsolute(templatePath) ? '' : __dirname + path.sep;
        const fileSystem = new FileSystem();
        const content: string = await fileSystem.read(basePath + templatePath);

        const includes: string[] = [];
        const results: any[][] = parse(content);
        results.forEach((result) => {
            if (result.length >= 4 && result[0] === '&' && result[1].startsWith('include:')) {
                includes.push(result[1]);
            }
        });

        if (includes.length > 0) {
            if (baseIncludePath === undefined) {
                baseIncludePath = path.dirname(basePath + templatePath) + path.sep;
            } else if (!path.isAbsolute(baseIncludePath)) {
                baseIncludePath = basePath + baseIncludePath;
            }
            await asyncForEach(includes, async (include) => {
                const includeParts: string[] = include.split(':');
                if (includeParts.length === 3 && view[include] !== undefined) {
                    const templateName: string = includeParts[2];
                    if (baseIncludePath.includes('/html')) {
                        Object.keys(view[include]).forEach((key) => {
                            view[include][key] = Array.isArray(view[include][key]) ? view[include][key].map((part: string) => part.replace(/(?:\r\n|\r|\n)/g, '<br>'))
                                : view[include][key].replace(/(?:\r\n|\r|\n)/g, '<br>');
                        });
                    }
                    view[include] = await this.render(path.resolve(baseIncludePath, templateName), view[include]);
                }
            });
        }

        const output: string = render(content, view);
        if (output.includes('{{') || output.includes('}}')) {
            throw new ConflictException('template: missing data to render template', {templatePath, data});
        }

        return templatePath.includes('html') ? this.minifier.html(output) : output;
    }
}
